import { motion } from 'framer-motion';
import { Star, Quote, ChevronDown } from 'lucide-react';

const testimonials = [
  {
    name: 'Olivia Fige',
    role: 'Proprietário',
    restaurant: 'Cantina',
    image: '/team/olivia.png',
    rating: 5,
    text: 'Desde que implementamos o AVAK, nosso tempo de atendimento caiu 40%. Os clientes adoram pedir pelo QR Code e a cozinha nunca mais perdeu um pedido.'
  },
  {
    name: 'Glenda Nacif',
    role: 'Gerente',
    restaurant: 'Pastelaria',
    image: '/team/glenda.png',
    rating: 5,
    text: 'O dashboard me dá visão completa do negócio. Consigo ver em tempo real o que está vendendo mais, controlar o estoque e tomar decisões com dados reais.'
  },
  {
    name: 'Lohan Fernandes',
    role: 'Chef e Proprietário',
    restaurant: 'Sushi Zen',
    image: '/team/lohan.png',
    rating: 5,
    text: 'O KDS na cozinha revolucionou nosso fluxo. Zero papel, zero confusão. Cada pedido aparece organizado com timer e prioridade. Simplesmente incrível!'
  }
];

const stats = [
  { value: '500+', label: 'Restaurantes ativos' },
  { value: '2M+', label: 'Pedidos processados' },
  { value: '98%', label: 'Satisfação' },
  { value: '24/7', label: 'Suporte' }
];

export default function Testimonials() {
  return (
    <section id="depoimentos" className="py-16 md:py-20 bg-white">
      <div className="container-custom">
        {/* Header */}
        <motion.div 
          className="text-center max-w-3xl mx-auto mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <span className="inline-block px-4 py-2 bg-blue-100 text-blue-600 rounded-full text-sm font-medium mb-4">
            Depoimentos
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            Quem usa, 
            <span className="text-blue-600"> recomenda</span>
          </h2>
          <p className="text-lg text-slate-600">
            Veja o que nossos clientes têm a dizer sobre a transformação 
            que o AVAK trouxe para seus negócios.
          </p>
        </motion.div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-20">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              className="bg-slate-50 rounded-2xl p-8 relative"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
            >
              {/* Quote Icon */}
              <div className="absolute -top-4 right-8">
                <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center">
                  <Quote className="w-5 h-5 text-white" />
                </div>
              </div>

              {/* Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                ))}
              </div>

              {/* Text */}
              <p className="text-slate-700 leading-relaxed mb-6">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-4">
                <img 
                  src={testimonial.image} 
                  alt={testimonial.name}
                  className="w-14 h-14 rounded-full object-cover"
                />
                <div>
                  <h4 className="font-bold text-slate-900">{testimonial.name}</h4>
                  <p className="text-sm text-slate-500">
                    {testimonial.role} · {testimonial.restaurant}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Stats - Metas da AVAK */}
        <motion.div 
          className="bg-gradient-to-r from-cyan-500 to-blue-600 rounded-3xl p-10 md:p-16"
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
        >
          {/* Título */}
          <div className="text-center mb-10">
            <h3 className="text-2xl md:text-3xl font-bold text-white">
              Metas da AVAK
            </h3>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-4xl md:text-5xl font-bold text-white mb-2">
                  {stat.value}
                </div>
                <div className="text-cyan-100">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </motion.div>

        {/* Indicador de mais conteúdo */}
        <motion.div 
          className="flex justify-center mt-12"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
        >
          <a href="#contato" className="flex flex-col items-center gap-2 text-slate-400 hover:text-blue-600 transition-colors">
            <span className="text-sm font-medium">Fale conosco</span>
            <motion.div
              animate={{ y: [0, 6, 0] }}
              transition={{ duration: 1.5, repeat: Infinity }}
            >
              <ChevronDown className="w-5 h-5" />
            </motion.div>
          </a>
        </motion.div>
      </div>
    </section>
  );
}
